import { request } from 'shared/lib/request';

export const contactHR = (formData) =>
  request.post('/contact-hr', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
